import {Passenger} from "@models/micro/passenger.model";
import {PAX_TYPE} from "@app/enums";
import { Segment } from "@models/micro/segment.model";
import { Declared } from "@app/utils/pecTab";
import { FreeTextInfoList } from "./response/viewDocuments.model";
import { Reservation } from "../reservation.model";

const isNumberRegExp = new RegExp('^\\d{1,2}$');

export class BoardinPass {
  pectabMap: any;
  languageInfo: string = '';
  passengers: Passenger[];
  boardinPassInfo: any;
  constructor(private pectab: string, passengers: Passenger[], segments: any[], language: string) {
    this.languageInfo = language;
    this.pectabMap = TrasformPectab.separate(pectab)
    for(let passenger of passengers) {
      passenger.mapBoardingPass = passenger.travelDocument.map(bp=> TrasformPectab.separate(bp));
      this.buildSkyCleared(passenger);
      this.buildSkyPriority(passenger);
      this.buildDeclared(passenger);
      this.buildTwoConfort(passenger);
      this.buildCHD(passenger);
      this.buildSTB(passenger);
      this.buildTerminal(passenger, segments);
      this.buildLoyalty(passenger);
    }
    this.passengers = passengers;
  }
  getDoctos () {
    let bpBoarding = [];
    const indexPectab = this.pectab.indexOf('^01');
    for(let passenger of this.passengers) {
      for(let bp of passenger.mapBoardingPass) {
        const indexTravelDoc = passenger.travelDocument[0].indexOf('^03');
        bpBoarding.push(`${passenger.travelDocument[0].substring(0, indexTravelDoc)+"^"+TrasformPectab.join(bp) }`)
      }
    }
    return {
      value: bpBoarding,
      pectab: `${this.pectab.substring(0, indexPectab)+"^"+TrasformPectab.join(this.pectabMap)}`
    }
  }

  addAtFormat(position: any, properties?: string) {
    this.pectabMap[position]??= properties;
  }
  addAtValue(el:  object, position: any, value: any) {
    el[position] = value;
  }

  buildSkyCleared(passenger: Passenger) {
    if(passenger.paxType !== PAX_TYPE.INFANT && passenger.isSkyCleared()) {
      this.addAtFormat(49, '02K20')
      this.addAtFormat(51, '10K23')
      this.addAtFormat(52, '04K34F')
      for (let bp of passenger.mapBoardingPass ) {
        this.addAtValue(bp, 49, '**')
        this.addAtValue(bp, 51, 'SKY CLEARED')
        this.addAtValue(bp, 52, '**')
      }
    }
    return this

  }

  buildDeclared(passenger: Passenger) {
    if(passenger.paxType !== PAX_TYPE.INFANT && !passenger.isSkyCleared() && passenger.isIsDeclaredCOVIDTest() ) {
      this.addAtFormat(49, '02K20')
      this.addAtFormat(51, '10K23')
      this.addAtFormat(52, '04K34F')
      for (let bp of passenger.mapBoardingPass ) {
        this.addAtValue(bp, 49, '**')
        this.addAtValue(bp, 51, Declared[this.languageInfo])
        this.addAtValue(bp, 52, '**')
      }
    }
    return this;
  }

  buildTwoConfort(passenger: Passenger) {
    if(passenger.paxType !== PAX_TYPE.INFANT && passenger.hasDobleConfort() ) {
      for (let bp of passenger.mapBoardingPass ) {
        this.addAtValue(bp, "B2", `${this.getFreeTextBuildTwoConfort(passenger.freeTextInfoList) + "AT"}`)
        }
      }
    return this
  }

  getFreeTextBuildTwoConfort(freeTextInfoList: FreeTextInfoList[]): string {
    for(let free of freeTextInfoList){
      if(free.editCode === 'NFST'){
        const posicionAT = free.text.indexOf('AT');
        const posicionInicio = posicionAT - 2;
        const valorAntesDeAT = free.text.slice(posicionInicio, posicionAT).trim();
        const palabras = free.text.split(' ');
        const segundaPalabra = palabras[1];
        return `${segundaPalabra}${valorAntesDeAT}`;
      }
    }
    return '';
  }

  buildCHD(passenger: Passenger) {
    if(passenger.paxType === PAX_TYPE.CHILD) {
      this.addAtFormat("B4", '05N46')
      for (let bp of passenger.mapBoardingPass ) {
        this.addAtValue(bp, "B4", 'CHILD')
      }
    }
    return this
  }

buildSTB(passenger: Passenger) {
    if(passenger.isStandBy) {
      for (let bp of passenger.mapBoardingPass ) {
        if(bp['B3'] !=='STB') {
          this.addAtValue(bp, 'B3', 'STB')
        }
      }
    }
    return this
  }

  buildSkyPriority(passenger: Passenger) {
    let sky = 'SKY' ;
    let priority = 'PRIORITY';
    if(passenger.paxType !== PAX_TYPE.INFANT && passenger.frequentFlyerName === 'GOLD') {
        for (let bp of passenger.mapBoardingPass ) {
          this.addAtValue(bp, 45, sky)
          this.addAtValue(bp, 47, sky)
          this.addAtValue(bp, 46, priority)
          this.addAtValue(bp, 48, priority)
        }
    }
    return this
  }

  buildTerminal(passenger: Passenger, segments: Segment[]) {
    for (let [idx, bp] of passenger.mapBoardingPass.entries() ) {
      let segment  = segments[idx];
      if(segment.departureAirport ===  'MEX') {
        this.addAtValue(bp, 60, bp[60] + ' T2')
      }
      else if(segment.arrivalAirport ===  'MEX') {
        this.addAtValue(bp, 70, bp[70] + ' T2')
      }
    }

  }

  buildLoyalty(passenger: Passenger) {
    const { passengerInfo } = passenger;
    if(passengerInfo && passengerInfo?.ffProgram) {
      for (let bp of passenger.mapBoardingPass ) {
        this.addAtFormat(84, '05O20L');
        this.addAtFormat(85, '02P20');
        this.addAtValue(bp, 84, 'Numero de viajero frecuente/Frequent flyer number');
        this.addAtValue(bp, 85, passengerInfo.ffNumber);
      }
    }

    return this;
  }
}


export class TrasformPectab {
  static separate(pectab: string): any {
    const data = {};
    const split = pectab.split("^");
    for (let [index, el] of split.entries()) {
      if(index > 6){
        const extract = el.substring(0,2) ;
        const key =  Number(extract) || extract;
        if(key){
          data[key] = el.substring(2);
        }

      }
    }
    return data

  }

  static join(map: any): string {
    const entries = Object.entries(map)
    .sort((a: any,b:any) => {
      const keyA:any = a[0];
      const keyB:any = b[0];

      if (!isNaN(keyA) && !isNaN(keyB)) {
        return Number(keyA) - Number(keyB);
      } else {
        return keyA.localeCompare(keyB);
      }
    })
    .map(([key,value])=>`${isNumberRegExp.test(key)?key.padStart(2,'0'):key}${value}`)

    return entries.join('^');
  }
}

